module.exports = __webpack_public_path__ + "img/video-cover-1.8db9a46c.png";